/**
 * @author sai shiva
 * @Date: 2022-09-13 14:35:11
 * @Last Modified by: sai shiva
 * @Last Modified time: 2022-09-13 16:20:42
 */
import styled from 'styled-components';
import theme from '../../theme';

const StyledWearables = styled.section`
  .first-content-bg{
    background: ${theme.saviourGradient};
    padding: 3rem 0rem;
  }
  .know-connect{
    border-right: 1px solid ${theme.borderGray};
    .app-logos{
      width: 145px;
      border-radius: 6px;
      padding: 6px 0px;
      background: ${theme.grylicBlack};
    }
  }
  .third-content-bg{
    background: ${theme.gradientWebGrayColor};
    .link-change{
      padding: 10px;
      border-bottom: 1px solid ${theme.lightBorder};
      color: ${theme.LandingBlack};
      font-weight: 600;
      font-size: 16px;
      cursor: pointer;
      span{
        width: 30px;
        height: 30px;
        background: ${theme.primaryColor};
        color: ${theme.whiteColor};
        padding: 10px;
        border-radius: 50%;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
      }
      &.active, :hover{
        background-color: ${theme.lightBorder};
      }
    }
    .wearable-points{
      height: 320px;
    }
    .iconic-wearable{
      width: 45px;
      height: 45px;
      background: ${theme.secondaryColor};
    }
  }
`;

export default StyledWearables;



// WEBPACK FOOTER //
// client/containers/Wearables/StyledWearables.js